<div class="datatable-page data-table-page">
    <div class="header-section">
      <h2 mat-dialog-title>{{ "LOCATION.FORM.TABS.SERVICES" | translate }}</h2>
      <div
        class="u-flex u-column u-gt-xs-row u-gt-xs-wrap u-gap-20 u-jc-end u-ai-center"
      >
        <button
          mat-raised-button
          id="serviceAddForm-save"
          color="accent"
          type="button"
          (click)="saveAndClose()"
        >
          {{ "ACTIONS.SAVE_CLOSE" | translate }}
        </button>
        <button
          mat-raised-button
          id="serviceAddForm-saveAndClose"
          color="primary"
          type="button"
          (click)="close()"
        >
          {{ "ACTIONS.CLOSE" | translate }}
        </button>

        <!-- Grid buttons -->
        <button
          mat-raised-button
          id="grid-columns-filter"
          matTooltip="{{ 'COMMON.COLUMNS' | translate }}"
          color="action"
          type="button"
          (click)="openColumnsPanel(dataGrid)"
        >
          <mat-icon>view_week</mat-icon>
          {{ "COMMON.COLUMNS" | translate }}
        </button>
      </div>
    </div>
    <bs-data-grid
      #dataGrid
      id="serviceAddForm-grid"
      [gridName]="'SelectServiceTable'"
      [columns]="columns"
      [formLink]="['#']"
      [rowClickNavigate]="false"
      [dataGridService]="dataGridService"
      [dataSource]="dataSource"
      [initialPageSize]="10"
      [selectedRows]="existingServiceIds"
    >
    </bs-data-grid>
</div>
